import React, { Component } from "react";
import PropTypes from "prop-types";
import Header from "../components/Header.js";
import icon from "../images/icone_page_500.svg";

export class Page500 extends Component {
  handleClick() {
    this.props.onLoadProcess();
  }

  render() {
    return (
      <div className="container h-100">
        <Header logo={this.props.logo} />
        <div className="row text-center px-4" style={{ minHeight: "calc(100vh - 106px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5">
            <img src={icon} style={{ maxHeight: "105px", color: "#a8c657" }} alt="" className="img-fluid mx-auto d-block mt-4" />
            <h1 className="card-title fw-bold text-white mt-5">ERRO INESPERADO</h1>
            <h5 className="card-text text-light mt-5">Algo deu errado. Tente novamente mais tarde.</h5>
            <div className="row mt-5 justify-content-center">
              <div className="col-8 d-grid">
                <button className="btn btn-primary fw-bold" type="button" onClick={() => this.handleClick()}>
                  VOLTAR PARA O INÍCIO
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Page500.propTypes = {
  onLoadProcess: PropTypes.func.isRequired,
};

export default Page500;
